import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import Style from '../css/cards/StaffPicksCardImage.module.css';
import removeCssFromACode from '../../../../util/removeCssFromACode';
import extractTextFromHtml from '../../../../util/extractTextAndWrapInH3';
import moment from 'moment';
import { createSlug } from '../../../../util/urlHelpers';

import ContentLoader from 'react-content-loader';
export const StaffPicksCardImage = ({ cardData }) => {
  const cardId = cardData?.id;
  const title = cardData?.title;
  const params = useParams();
  const lang = params?.lang;
  const history = useHistory();

  const handelClick = () => {
    history.push(`/${lang}/blog/q?&id=${cardId}${title ? '&name=' + createSlug(title) : ''} `);
  };
  const firstImage = cardData?.featuredImage;
  const firstH1Match = cardData?.content;
  const first30Words = extractTextFromHtml(cardData?.content);
  moment.locale('es');

  function formatDateInSpanish(inputDate) {
    const date = moment(inputDate);

    if (!date.isValid()) {
      return 'Fecha inválida';
    }

    return date.format('DD/MM/YYYY'); // Date formatted in "DD/MM/YYYY"
  }
  return (
    <div onClick={handelClick} className={Style.StaffPicksCardImage}>
      <img src={firstImage} alt={cardData?.title} className={Style.image_with_iamge_card} />
      <div className={Style.container_details}>
        <div className={Style.creator_container}>
          {/* <img className={Style.creator_image} src={firstImage?.url} /> */}
          <div className={Style.author_creatore_text}>
            {/* <span className={`${Style.each_data_element_bottom} ${Style.author}`}>
              {cardData?.author}
            </span> */}
            <span className={Style.each_data_element_bottom}>
              {formatDateInSpanish(cardData.createdAt)}
            </span>
            <span className={Style.each_data_element_bottom}>{cardData?.publication}</span>
          </div>
        </div>
        <h3 className={Style.title_card_image}>{title}</h3>

        <p className={Style.text_description}>
          {first30Words?.slice(0, 120)}
          <span className={Style.read_more}>...leer más</span>
        </p>
        {/* <div className="publication_text">
            <p className="each_publication_text">{cardData?.publication}</p>
          </div> */}
      </div>
    </div>
  );
};

export const SkeletonStaffPicksCardImage = ({ elementNumber }) => {
  return (
    <>
      {new Array(elementNumber).fill(
        <ContentLoader width={500} height={200} backgroundColor="#E6E6E6" foregroundColor="#fafafa">
          <rect x="200" y="15" rx="5" ry="5" width="300" height="15" />
          <rect x="200" y="39" rx="5" ry="5" width="220" height="9" />
          <rect
            x="20"
            y="10"
            rx="0"
            ry="0"
            width="160"
            height="160"
            borderRadius="20px"
            style={{ borderRadius: '20px' }}
          />
        </ContentLoader>
      )}
    </>
  );
};
